var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 90,
    viewBox: "0 0 56 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3071 1H2.58802L2.55328 35.0947L3.57678 39.9214L4.95505 42.2584L6.96254 43.0974L7.71161 45.0449L6.06367 47.9214L5.46442 50.588L4.17603 52.4157L4.41573 53.5543L3.57678 55.1124L2.40824 55.8015L1 59.0674L1.26966 61.4944L2.97753 61.794L3.81648 62.9326L3.21723 64.5506L2.6779 66.6479V89L55.1723 88.8202V59.0375L52.2659 55.5318L49.9588 57.809L48.3708 58.7378L44.8652 57.809L43.5168 59.2772L40.8502 58.5581L39.6517 60.4157L38.1536 59.2772L36.4157 54.3933L35.4569 55.3221L33.6292 54.0637L34.0487 52.176L31.1423 47.5019L30.4831 44.5655L29.3146 43.6367L26.4082 46.9026L24.3109 45.5243L24.8801 44.1461L24.3109 42.3783L25.779 41.5393L24.8801 37.9139L25.779 34.4981L26.2285 31.6217L23.9813 32.0412L23.4419 30.573L22.4232 30.9626L22.2434 29.7041L21.015 28.1161L18.1985 25L17.8389 24.0412L15.9213 23.0225L13.9139 21.794L14.4831 19.6667L13.9139 19.0075V18.1386L11.3071 14.573V1Z",
    fill: "#273137",
    fillOpacity: 0.1,
    stroke: "#273137",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgId);
export default __webpack_public_path__ + "static/media/ID.52187cb2df8d6bba2232445b37423b13.svg";
export { ForwardRef as ReactComponent };